import React from "react";
import { useTranslation } from "react-i18next";

/**
 * MobileWhy2 - Versión móvil optimizada
 * - Fondo oscuro simple
 * - Sin Macbook scroll (demasiado pesado)
 * - Lista de beneficios con iconos
 */
const MobileWhy2: React.FC = () => {
  const { t } = useTranslation();

  const benefits = [
    t(
      "home.why2.bullet1",
      "Access comprehensive, evidence-based medical databases in seconds."
    ),
    t("home.why2.bullet2", "Get real-time support for complex cases."),
    t("home.why2.bullet3", "Never feel alone during emergencies."),
    t("home.why2.bullet4", "Increase efficiency and focus on patient care."),
  ];

  return (
    <section
      className="relative py-16 px-4"
    >
      <div className="container mx-auto max-w-4xl">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-[#00342d] leading-tight">
            {t("home.why2.title", "Designed to support you 24/7")}
          </h2>
        </div>

        {/* Benefits List */}
        <div className="space-y-4 mb-12">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="flex items-start space-x-4 bg-white rounded-xl p-5 border border-gray-100 shadow-sm"
            >
              {/* Icon */}
              <div className="flex-shrink-0 w-10 h-10 bg-[#e6fffa] rounded-full flex items-center justify-center">
                <svg
                  className="w-5 h-5 text-[#00e9be]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>

              {/* Text */}
              <p className="text-gray-700 leading-relaxed flex-1 font-medium">{benefit}</p>
            </div>
          ))}
        </div>

        {/* Image placeholder - opcional */}
        <div className="rounded-2xl overflow-hidden bg-white border border-gray-200 shadow-lg">
          <div className="aspect-video bg-gradient-to-br from-[#e6fffa] to-white flex items-center justify-center">
            <div className="text-center">
              <div className="text-6xl mb-4">💻</div>
              <p className="text-gray-500 text-sm font-medium">
                {t("home.why2.imageAlt", "24/7 Veterinary Support")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MobileWhy2;
